import { MeasurementSystem } from "config/constants"
import i18n from "intl/i18n"

export interface IUnitDto {
    id: string
    measurementSystem: string
    lengthUnitsAlias: string
}

export default class Unit {
    id: string
    system: MeasurementSystem
    unit: string

    constructor(dto: IUnitDto) {
        this.id = dto.id
        this.system = dto.measurementSystem as MeasurementSystem
        this.unit = dto.lengthUnitsAlias
    }

    print() {
        let label = ""

        if (this.system === MeasurementSystem.metric) {
            label = i18n.t('unit.metric')
        } else if (this.system === MeasurementSystem.imperial) {
            label = i18n.t('unit.imperial')
        }

        label = label ? [label, this.unit].join(", ") : this.unit
        return label
    }

    printShort() {
        return this.unit
    }
}
